import { render, staticRenderFns } from "./HomeComparison.vue?vue&type=template&id=86043cc4&scoped=true&"
import script from "./HomeComparison.vue?vue&type=script&lang=js&"
export * from "./HomeComparison.vue?vue&type=script&lang=js&"
import style0 from "./HomeComparison.vue?vue&type=style&index=0&id=86043cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86043cc4",
  null
  
)

export default component.exports